// GMap component - Converted from components/GMap.vue
// Google Maps iframe component
// Converted: <template> -> JSX
import React from 'react';

const GMap = () => {
  return (
    <section className="google_map">
      <iframe
        src="https://www.google.com/maps?q=Les+Berges+du+Lac+2,+Tunis,+Tunisie&output=embed"
        className="google-map__contact"
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Google Map - Les Berges du Lac 2, Tunis"
      ></iframe>
    </section>
  );
};

export default GMap;
